export default __webpack_public_path__ + "static/media/pic2.e02f6db1.jpg";